var exports = {
  "M0": "VoiceSceneTv.module__bar___V01LRl",
  "hB": "VoiceSceneTv.module__glassButton___V01LRl",
  "Ie": "VoiceSceneTv.module__empty___V01LRl",
  "Yo": "VoiceSceneTv.module__emptyLight___V01LRl",
  "Mv": "VoiceSceneTv.module__voiceSceneTvDrift___V01LRl",
  "oJ": "VoiceSceneTv.module__emptyClock___V01LRl",
  "_U": "VoiceSceneTv.module__emptyTitle___V01LRl",
  "LA": "VoiceSceneTv.module__emptyHint___V01LRl",
  "Fc": "VoiceSceneTv.module__emptyChannel___V01LRl",
  "Ki": "VoiceSceneTv.module__video___V01LRl",
  "pc": "VoiceSceneTv.module__videoFrame___V01LRl",
  "iO": "VoiceSceneTv.module__videoThumbnail___V01LRl",
  "v$": "VoiceSceneTv.module__videoHint___V01LRl",
  "OD": "VoiceSceneTv.module__videoHintPill___V01LRl",
  "UJ": "VoiceSceneTv.module__videoHintIcon___V01LRl",
  "pD": "VoiceSceneTv.module__volume___V01LRl",
  "Wh": "VoiceSceneTv.module__volumeIcon___V01LRl",
  "MQ": "VoiceSceneTv.module__volumeSlider___V01LRl",
  "ns": "VoiceSceneTv.module__linkForm___V01LRl",
};

module.exports = exports;
